import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { ButtonStyles } from '@stories/Elements/Forms/Buttons/Button.styles';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import styled from 'styled-components';

const DownloadWrapper = styled.div`
  background-color: ${brand.white};

  border-left-width: 4px;
  border-left-style: solid;
  width: 100%;
`;

const DownloadContent = styled.a`
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  ${() => ButtonStyles.LinkElement}, ${() => ButtonStyles.ButtonElement} {
    ${fonts.helvetica['63-medium-extended']}
    font-size: 14px;
    flex-shrink: 0;
  }

  @media ${until(Device.Tablet)} {
    flex-direction: column;
    align-items: start;
  }
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    ${Typography.H5Style}
    color: ${brand.black};
  }

  h2 {
    ${Typography.PStyle}
    color: ${brand.grey[80]};
  }
`;

export const DocumentDownloadCardStyles = {
  DownloadWrapper,
  DownloadContent,
  ProductInfo,
};
